import { createStore, combine, sample } from 'effector'
import {
  getCaseContentFx,
  getCaseListFx,
  getShopItemsFx,
  getUniqueContentFx,
  openCaseFx,
  videoHasBeenLoadedFx,
} from './effects'
import { openCasePage, setOpenedLbKind, setCaseId, setSelectedPurchaseCurrency } from './events'
import { Case, RewardType, SelectedPurchaseOption, ShopItemType } from './types'
import { goToCase } from '@/app/routing/events'

const $casesList = createStore<Case[] | null>(null).on(getCaseListFx.doneData, (_, data) => data.lootboxes)

const $lastClaimDate = createStore<string | null>(null).on(
  getCaseListFx.doneData,
  (_, data) => data.last_claimed_key_dt
)

const $nextClaimKeyDate = createStore<string | null>(null).on(
  getCaseListFx.doneData,
  (_, data) => data.next_claimed_key_dt
)

export const $isOpenedFree = createStore<boolean>(JSON.parse(localStorage.getItem('isOpenedFree') || 'false')).on(
  setOpenedLbKind,
  (_, data) => data
)

const $userKeys = createStore<number | null>(null)
  .on(getCaseListFx.doneData, (_, data) => {
    return data.keys
  })
  .on(openCaseFx.doneData, (_, data) => {
    return data.keys
  })

export const $isVideoLoaded = createStore<boolean>(false).on(videoHasBeenLoadedFx.doneData, (_, data) => data.status)

const $caseContent = createStore<RewardType[] | null>(null).on(getCaseContentFx.doneData, (_, data) => {
  return data.contents
})

const $rewardId = createStore<number | null>(null).on(openCaseFx.doneData, (_, data) => data.content.id ?? 1)
const $freeBoxReward = createStore<RewardType | null>(null).on(openCaseFx.doneData, (_, data) => data.content)
export const $lastViewedCaseId = createStore<number | null>(Number(localStorage.getItem('lastViewedCaseId')))
  .on(openCasePage, (_, payload) => {
    if (payload.id) {
      localStorage.setItem('lastViewedCaseId', payload.id.toString())
      return payload.id
    }
    return 1
  })
  .on(setCaseId, (_, id) => {
    if (id) {
      localStorage.setItem('lastViewedCaseId', id.toString())
      return id
    }
    return 1
  })
  .on(goToCase, (_, payload) => {
    if (payload.id) {
      localStorage.setItem('lastViewedCaseId', payload.id.toString())
      return payload.id
    }
    return 1
  })

export const $lastViewedCasePrice = combine($casesList, $lastViewedCaseId, (casesList, lastViewedCaseId) => {
  if (!casesList || !lastViewedCaseId) return null
  const selectedBox = casesList.find((_case) => _case.id === lastViewedCaseId)
  return selectedBox ? selectedBox.price_keys : null
})

type KeyPriceType = {
  id: number
  amount: number
  price_stars: number
}

const $keyPrices = createStore<KeyPriceType[] | null>(null).on(getCaseListFx.doneData, (_, data) => data.key_prices)

export const $lastRewardFromCase = createStore<{ reward: RewardType | null; timestamp: number }>({
  reward: JSON.parse(localStorage.getItem('lastCaseReward') || 'null'),
  timestamp: 0,
})

sample({
  clock: openCaseFx.doneData,
  fn: (reward) => {
    localStorage.setItem('lastCaseReward', JSON.stringify(reward.content))
    return { reward: reward.content, timestamp: Date.now() }
  },
  target: $lastRewardFromCase,
})

export const $uniqueCaseContent = createStore<[boolean, string][] | null>(null).on(
  getUniqueContentFx.doneData,
  (_, data) => data
)

export const $boxPreview = createStore<boolean>(false).on(openCasePage, (_, payload) => payload.onPrewiew)
export const $shopItems = createStore<ShopItemType[] | null>(null).on(getShopItemsFx.doneData, (_, data) => data)
export const $selectedPurchaseOption = createStore<SelectedPurchaseOption>({ currency: 'keys', price: 1 }).on(
  setSelectedPurchaseCurrency,
  (_, option) => option
)
export { $casesList, $nextClaimKeyDate, $userKeys, $caseContent, $rewardId, $lastClaimDate, $keyPrices, $freeBoxReward }
